import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/static/icons/recommend_icon.svg'
import _imports_1 from '@/static/icons/swipe-chevron.svg'
import _imports_2 from '@/static/icons/add-to-cart-white.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "product-card__image-spacer" }, null, -1)
const _hoisted_2 = { class: "product-card__details-container" }
const _hoisted_3 = {
  key: 0,
  class: "product-card__brand-recommend-wrapper"
}
const _hoisted_4 = {
  key: 0,
  class: "product-card__brand-name"
}
const _hoisted_5 = {
  key: 1,
  class: "product-card__vertical-divider"
}
const _hoisted_6 = {
  key: 2,
  class: "product-card__recommend-container"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "product-card__recommend-icon",
  src: _imports_0,
  alt: "Rekommendera"
}, null, -1)
const _hoisted_8 = { class: "product-card__recommend-text" }
const _hoisted_9 = { class: "product-card__product-name" }
const _hoisted_10 = { class: "product-card__price-vat-wrapper" }
const _hoisted_11 = {
  key: "skeleton",
  class: "product-card__price-skeleton"
}
const _hoisted_12 = { class: "product-card__customer-price-error" }
const _hoisted_13 = { class: "product-card__number-of-variants" }
const _hoisted_14 = { class: "product-card__tags" }
const _hoisted_15 = {
  key: 1,
  class: "product-card__stock-status"
}
const _hoisted_16 = {
  key: 0,
  class: "product-card__swipe-container"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  class: "product-card__swipe-chevron",
  src: _imports_1,
  alt: "swipe icon"
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "product-card__add-to-cart-container" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "product-card__add-to-cart-image",
  src: _imports_2
}, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "product-card__add-to-cart-text"
}

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

import { useGA4 } from '@distancify-storefront/tracking-gtm';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useContext from '@/composables/useContext';
import useLitium from '@/composables/useLitium';
import useVariantPrices from '@/composables/useVariantPrices';

import { deviceWidths } from '../constants';

import ProductTag from './product/ProductTag.vue';
import BundleTag from './product/BundleTag.vue';
import DisplayPrice from './DisplayPrice.vue';
import Skeleton from './Skeleton.vue';
import useStock from '../composables/useStock';
import ImageWithFallback from '@/components/ImageWithFallback.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
  product: {
    type: Object,
    required: true,
  },
  categoryData: {
    type: Object,
  },
  categoryIndex: {
    type: Number,
  },
},
  emits: ['open-add-to-cart'],
  setup(__props, { emit }) {

const props = __props;





const { mitt } = useContext();

const { websiteText } = useWebsiteTexts();
const { plpStockStatusText } = useStock();
const ga4 = useGA4({ useLegacyEnhancedECommerce: true });
const { toLitiumMediaUrl } = useLitium();

const stockStatusText = plpStockStatusText(props.product);

const scrollContainer = ref<HTMLDivElement | null>(null);
const cloakedItem = ref<HTMLDivElement | null>(null);
const cartItem = ref<HTMLDivElement | null>(null);
const mediaContainer = ref<HTMLDivElement | null>(null);

const image = ref(
  props.product?.fields?._images?.value?.[0] ||
    props.product.selectedVariant?.fields?._images?.value?.[0] ||
    props.product.variants?.[0]?.fields?._images?.value?.[0]
);

const lowResolutionImage = ref(
  image.value?.imageId && {
    url: toLitiumMediaUrl(image.value.imageId, { maxWidth: 50 }),
    alt: image.value.alt,
  }
);

const highResolutionImage = ref<{ url: string; alt: any }>();
const displayedImage = ref(lowResolutionImage.value);
const isImageDownloaded = ref(false);
const isMounted = ref(false);
const isPhoneDevice = ref(false);
const observer = ref<any>(null);

const url = computed(() => {
  return props.product.url || '';
});

const selectedVariant = computed(() => {
  return props.product.selectedVariant || props.product.variants?.[0];
});

const articleNumber = computed(() => {
  return props.product.articleNumber || props.product.id;
});

const productFields = computed(() => {
  return props.product.fields;
});

const brand = computed(() => {
  return productFields.value?.brand?.value?.label;
});

const name = computed(() => {
  return productFields.value?._name?.value;
});

const { unitPrice, campaignPrice, isBusy, fetchCustomerPriceError, isCustomerPriceDifferent } = useVariantPrices(selectedVariant);

const tag = computed(() => {
  if (props.product?.fields?.tag?.value) {
    return props.product?.fields?.tag?.value;
  }

  if (
    selectedVariant.value?.priceFlag === 'MATCHED' &&
    !isCustomerPriceDifferent.value
  ) {
    return {
      label: websiteText('product__tag_pricematched').value,
      value: 'pricematched',
    };
  }

  if (
    selectedVariant.value?.priceFlag === 'CAMPAIGN' &&
    !isCustomerPriceDifferent.value
  ) {
    return {
      label: websiteText('product__tag_campaign').value,
      value: 'campaign',
    };
  }

  if (
    selectedVariant.value?.priceFlag === 'OUTLET' &&
    !isCustomerPriceDifferent.value
  ) {
    return {
      label: websiteText('product__tag_outlet').value,
      value: 'outlet',
    };
  }

  return null;
});

const isBundle = computed(() => {
  return props.product?.selectedVariant?.isBundle ?? false;
})

const tagsCount = computed(()=> {
  const tags = [tag.value ? true : false, isBundle.value];
  return tags.filter(t=> t).length;
})

const numberOfRecommendations = computed(() => {
  return productFields.value?.numberOfReviews?.value;
});

const numberOfVariants = computed(() => {
  const amount = props.product.variantsCount || props.product.variants?.length;
  return amount > 1
    ? websiteText('product__info__number_of_variants', {
        amount: amount,
      }).value
    : '';
});

const isMultiPriced = computed(() => {
  return props.product.isMultiPriced;
});

onMounted(() => {
  window.addEventListener('resize', checkWindowSize);

  isPhoneDevice.value = window.innerWidth <= deviceWidths.phoneMaxWidth;
  isMounted.value = true;

  addObserver();

  if (!displayedImage.value) {
    return;
  }

  const containerHeight =
    Math.ceil(
      (mediaContainer.value?.clientHeight! * window.devicePixelRatio) / 10
    ) * 10;

  highResolutionImage.value = {
    url: toLitiumMediaUrl(image.value.imageId, {
      maxHeight: containerHeight,
    }),
    alt: image.value.alt,
  };

  const img = new Image();

  img.onload = () => {
    displayedImage.value = highResolutionImage.value;
    isImageDownloaded.value = true;
  };

  if (highResolutionImage.value) {
    img.src = highResolutionImage.value.url;
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkWindowSize);
  observer.value?.disconnect();
});

function checkWindowSize() {
  isPhoneDevice.value = window.innerWidth <= deviceWidths.phoneMaxWidth;
}

function openAddToCart() {
  if (articleNumber.value) {
    mitt.emit('Category:AddToCart:Open', articleNumber.value);
  } else {
    console.warn(
      'Failed to open the add to cart modal due to invalid base product id'
    );
  }
}

function addObserver() {
  if (!isPhoneDevice.value) return;

  const options = {
    root: scrollContainer.value,
    rootMargin: '0px',
    threshold: 0.5,
  };

  observer.value = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        cloakedItem.value?.classList.add('product-card__gradient');
      } else {
        cloakedItem.value?.classList.remove('product-card__gradient');
      }
    });
  }, options);

  observer.value.observe(cartItem.value);
}

function pushGA4ClickEvent() {
  ga4.selectItem({
    itemListId: props.categoryData?.systemId
      ? `category_${props.categoryData.systemId}`
      : undefined,
    itemListName: props.categoryData?.googleAnalyticsName
      ? `Category: ${props.categoryData.googleAnalyticsName}`
      : undefined,
    item: {
      item_id: props.product.articleNumber,
      item_name: props.product.googleAnalyticsName,
      discount:
        (props.product.selectedVariant?.price?.listPrice ||
          props.product.variants?.[0]?.price?.listPrice ||
          0) -
        (props.product.selectedVariant?.price?.campaignPrice ||
          props.product.variants?.[0]?.price?.campaignPrice ||
          0),
      price: props.product.variants?.[0]?.price?.listPrice,
      item_brand: brand.value,
      index: props.categoryIndex,
    },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "product-card__wrapper",
    ref_key: "scrollContainer",
    ref: scrollContainer
  }, [
    _createVNode(_component_router_link, {
      to: _unref(url),
      custom: "",
      class: "product-card",
      onClick: pushGA4ClickEvent
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "product-card__gradient-container",
          ref_key: "cloakedItem",
          ref: cloakedItem
        }, null, 512),
        _createElementVNode("div", {
          class: "product-card__image-container",
          ref_key: "mediaContainer",
          ref: mediaContainer
        }, [
          _hoisted_1,
          (isMounted.value)
            ? (_openBlock(), _createBlock(ImageWithFallback, {
                key: 0,
                class: "product-card__image",
                image: displayedImage.value?.url,
                alt: displayedImage.value?.alt,
                loading: "lazy"
              }, null, 8, ["image", "alt"]))
            : _createCommentVNode("", true)
        ], 512),
        _createElementVNode("div", _hoisted_2, [
          (_unref(brand) || _unref(numberOfRecommendations))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_unref(brand))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(brand)), 1))
                  : _createCommentVNode("", true),
                (_unref(brand) && _unref(numberOfRecommendations))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                  : _createCommentVNode("", true),
                (_unref(numberOfRecommendations))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(numberOfRecommendations)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(name)), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_Transition, {
              name: "dissolve",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (!_unref(isBusy))
                  ? (_openBlock(), _createBlock(DisplayPrice, {
                      key: "displayPrice",
                      class: "product-card__price",
                      "original-price": _unref(unitPrice),
                      "campaign-price": _unref(campaignPrice),
                      "vertical-stack": true,
                      "multi-price": _unref(isMultiPriced)
                    }, null, 8, ["original-price", "campaign-price", "multi-price"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(Skeleton, { class: "product-card__price-skeleton-original" }),
                      _createVNode(Skeleton, { class: "product-card__price-skeleton-discounted" })
                    ]))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(fetchCustomerPriceError)), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(numberOfVariants)), 1),
          _createElementVNode("div", _hoisted_14, [
            (_unref(tag))
              ? (_openBlock(), _createBlock(ProductTag, {
                  key: 0,
                  class: "product-card__tag",
                  tag: _unref(tag)
                }, null, 8, ["tag"]))
              : _createCommentVNode("", true),
            (_unref(isBundle))
              ? (_openBlock(), _createBlock(BundleTag, {
                  key: 1,
                  class: _normalizeClass(['product-card__tag', `product-card__tag--${_unref(tagsCount)}`])
                }, null, 8, ["class"]))
              : _createCommentVNode("", true)
          ]),
          (_unref(stockStatusText))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(stockStatusText)), 1))
            : _createCommentVNode("", true)
        ]),
        (isPhoneDevice.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", {
      class: "product-card__actions",
      ref_key: "cartItem",
      ref: cartItem
    }, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openAddToCart())),
        class: "product-card__add-to-cart"
      }, [
        _createElementVNode("span", _hoisted_19, [
          _hoisted_20,
          (isPhoneDevice.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_unref(websiteText)('product__action__add').value), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512)
  ], 512))
}
}

})